/* Lagoon Lumi — production bundle. Generated 2026-05-17T19:14:02.322Z
   Drop into Shopify theme /assets/lagoon-lumi.js and load via the
   sections/lagoon-sleep-concierge.liquid file. */


/* === pillow-engine.js === */
// pillow-engine.js — Recommendation logic derived from the Lagoon pillow-finder
// spreadsheet. Each pillow has 0–10 weights against the answer choices for six
// question dimensions: concern, position, temperature, body, density, height.
// We score by summing the weights for the user's selected answers, normalize,
// and surface the top match + runner-up + reasoning.

window.LAGOON_PILLOWS = [
  {
    id: 'chinchilla',
    name: 'The Chinchilla',
    tagline: 'Soft, low-loft, plush — like sinking into a cloud.',
    price: 139.99,
    url: 'https://lagoonsleep.com/products/the-chinchillla-recommend',
    accent: '#C8B6A6',
    image: 'chinchilla',
    bestFor: ['Stomach sleepers', 'Slender builds', 'Soft feel lovers'],
    feel: 'Soft & airy · Low loft',
  },
  {
    id: 'puffin',
    name: 'The Puffin',
    tagline: 'Plush comfort with a touch of structure — versatile, balanced.',
    price: 139.99,
    url: 'https://lagoonsleep.com/products/the-puffin-recommend',
    accent: '#B7C9C5',
    image: 'puffin',
    bestFor: ['Back sleepers', 'Cold sleepers', 'Plush + supportive'],
    feel: 'Cushy · Low–medium loft',
  },
  {
    id: 'fox',
    name: 'The Fox',
    tagline: 'Cradling memory foam — quiets tossing, holds your shape.',
    price: 139.99,
    url: 'https://lagoonsleep.com/products/the-fox-recommend',
    accent: '#D69B6E',
    image: 'fox',
    bestFor: ['Combo sleepers', 'Neck pain', 'Toss & turn'],
    feel: 'Cushy & cradling · Medium loft',
  },
  {
    id: 'otter',
    name: 'The Otter',
    tagline: 'Cool, supportive, side-sleeper favorite — pressure relief built in.',
    price: 139.99,
    url: 'https://lagoonsleep.com/products/the-otter-recommend',
    accent: '#7AAFB8',
    image: 'otter',
    bestFor: ['Side sleepers', 'Broad shoulders', 'Sleeps a little hot'],
    feel: 'Firm & supportive · Medium–high loft',
  },
  {
    id: 'polarbear',
    name: 'The Polar Bear',
    tagline: 'Cooling adjustable fill — the iciest pillow Lagoon makes.',
    price: 199.99,
    url: 'https://lagoonsleep.com/products/the-polar-bear-reversible-adjustable-cooling-pillow-copy',
    accent: '#9EC6E0',
    image: 'polarbear',
    bestFor: ['Hot sleepers', 'Side sleepers', 'Adjustable loft'],
    feel: 'Firm & adjustable · Medium–high loft',
  },
];

// Weights extracted from the spreadsheet (Queen variant rows).
// Each cell is 0–10. Higher = better fit.
window.LAGOON_WEIGHTS = {
  //                concern: toss, neck, hot, snore, wrinkles, none
  //                position: side, back, stomach, combo
  //                temp: hot, neutral, cold
  //                body: slender, average, broad
  //                density: soft, cushy, firm, notsure
  //                height: low, medium, high, notsure
  chinchilla: {
    concern:  { toss: 4,  neck: 6,  hot: 0,  snore: 0,  wrinkles: 10, none: 5 },
    position: { side: 2,  back: 3,  stomach: 10, combo: 2 },
    temp:     { hot: 0,   neutral: 5,  cold: 10 },
    body:     { slender: 10, average: 5,  broad: 0 },
    density:  { soft: 10, cushy: 3,  firm: 0,  notsure: 5 },
    height:   { low: 10,  medium: 2, high: 0, notsure: 5 },
  },
  puffin: {
    concern:  { toss: 6,  neck: 6,  hot: 0,  snore: 0,  wrinkles: 6,  none: 5 },
    position: { side: 4,  back: 10, stomach: 8,  combo: 4 },
    temp:     { hot: 0,   neutral: 5,  cold: 10 },
    body:     { slender: 7, average: 5, broad: 10 },
    density:  { soft: 9,  cushy: 4,  firm: 0,  notsure: 5 },
    height:   { low: 10,  medium: 6, high: 0, notsure: 5 },
  },
  fox: {
    concern:  { toss: 10, neck: 8,  hot: 0,  snore: 6,  wrinkles: 0,  none: 5 },
    position: { side: 6,  back: 10, stomach: 6,  combo: 10 },
    temp:     { hot: 0,   neutral: 5,  cold: 10 },
    body:     { slender: 5, average: 5, broad: 8 },
    density:  { soft: 5,  cushy: 10, firm: 5,  notsure: 5 },
    height:   { low: 5,   medium: 10, high: 6, notsure: 5 },
  },
  otter: {
    concern:  { toss: 8,  neck: 9,  hot: 8,  snore: 6,  wrinkles: 0,  none: 5 },
    position: { side: 10, back: 8,  stomach: 3,  combo: 10 },
    temp:     { hot: 9,   neutral: 5,  cold: 0 },
    body:     { slender: 5, average: 5, broad: 10 },
    density:  { soft: 3,  cushy: 8,  firm: 8,  notsure: 5 },
    height:   { low: 5,   medium: 10, high: 8, notsure: 5 },
  },
  polarbear: {
    concern:  { toss: 6,  neck: 8,  hot: 10, snore: 6,  wrinkles: 0,  none: 5 },
    position: { side: 10, back: 4,  stomach: 0,  combo: 6 },
    temp:     { hot: 10,  neutral: 5,  cold: 0 },
    body:     { slender: 5, average: 5, broad: 10 },
    density:  { soft: 0,  cushy: 5,  firm: 10, notsure: 5 },
    height:   { low: 2,   medium: 8, high: 10, notsure: 5 },
  },
};

// Question multipliers — match the post-3/20/26 production simulator weights.
// Position is the highest-information question, then density. Concerns/goals
// are small because product weights are nearly-neutral on them.
//
// Lagoon's own simulator already calibrates the output distribution toward
// the target mix — we DO NOT add an additional drift bonus on top. The
// engine here aligns to production, it doesn't second-guess it.
window.LAGOON_QUESTION_WEIGHTS = {
  position: 40,
  density:  20,
  body:     10,
  temp:     10,
  height:   10,
  concern:   5,
  goals:     5,
};

// Reference only — used in the strategy artboard, not in scoring.
window.LAGOON_TARGET_MIX = {
  otter:      0.50,
  fox:        0.20,
  polarbear:  0.15,
  chinchilla: 0.09,
  puffin:     0.06,
};

// 30-day sales mix (Apr 16 – May 16 2026). Used as social proof in the rec
// card ("our #1 best-seller this month") and in the strategy artboard.
window.LAGOON_SALES_30D = {
  totals: {
    otter:      663,
    fox:        203,
    chinchilla: 109,
    polarbear:   90,
    puffin:       1,
  },
  shares: {
    otter:      0.622,
    fox:        0.190,
    chinchilla: 0.102,
    polarbear:  0.084,
    puffin:     0.001,
  },
  rank: ['otter', 'fox', 'chinchilla', 'polarbear', 'puffin'],
};

// Score given an answers object: { concern, position, temp, body, density, height, goals?[] }
// Returns sorted pillows with normalized confidence (0–100).
// Applies misfit penalties learned from low-star reviews + returns.
window.scorePillows = function(answers) {
  const W = window.LAGOON_WEIGHTS;
  const QW = window.LAGOON_QUESTION_WEIGHTS;
  const dims = ['concern', 'position', 'temp', 'body', 'density', 'height'];
  const misfitFlags = window.LAGOON_MISFIT_FLAGS || {};
  const misfitCombos = window.LAGOON_MISFIT_COMBOS || [];

  const scored = window.LAGOON_PILLOWS.map(p => {
    let raw = 0;
    let max = 0;
    dims.forEach(d => {
      if (answers[d]) {
        const w = QW[d] || 1;
        raw += (W[p.id][d][answers[d]] || 0) * w;
        max += 10 * w;
      }
    });
    // Single-dim misfit penalties (scaled by that question's weight).
    const penalties = [];
    (misfitFlags[p.id] || []).forEach(f => {
      if (answers[f.dim] === f.value && f.penalty > 0) {
        const w = QW[f.dim] || 1;
        raw -= f.penalty * w;
        penalties.push(f.why);
      }
    });
    // Combo penalties (rules across two dims).
    misfitCombos.forEach(c => {
      if (c.pillow !== p.id) return;
      if (Object.entries(c.when).every(([k, v]) => answers[k] === v)) {
        raw -= c.penalty * 5;
        penalties.push(c.why);
      }
    });

    return { ...p, raw, max, penalties };
  });

  scored.sort((a, b) => b.raw - a.raw);
  // Normalize confidence so top scorer maps to ~ 80–96%.
  const top = Math.max(1, scored[0].raw);
  scored.forEach((p, i) => {
    p.confidence = Math.max(40, Math.round(Math.min(96, (p.raw / top) * 88 + (i === 0 ? 8 : 0))));
  });
  return scored;
};

// Cross-sell logic — pulled from the top-selling accessories in the 30-day data.
// Returns 1 complementary product suggestion for a given pillow recommendation
// + answer profile.
window.suggestComplement = function(pillowId, answers) {
  const coolingPillows = ['fox', 'otter', 'polarbear'];

  if (coolingPillows.includes(pillowId)) {
    return {
      id: 'cooling-pillowcase',
      name: 'Cooling Flex Pillowcase',
      tagline: 'Pairs with cooling memory foam — 101 sold this month.',
      price: 89.99,
      url: 'https://lagoonsleep.com/products/cooling-flex-performance-pillowcase',
    };
  }

  // Chinchilla and Puffin
  return {
    id: 'silk-pillowcase',
    name: 'Mulberry Silk Luxe Pillowcase',
    tagline: 'Gentle on skin and hair.',
    price: 89.99,
    url: 'https://lagoonsleep.com/products/100-mulberry-silk-luxe-pillowcase',
  };
};

// Reasoning copy fragments by answer — used to assemble "Why this pillow" bullets.
window.LAGOON_REASONS = {
  concern: {
    toss:     'helps quiet tossing and turning',
    neck:     'targets neck & shoulder relief',
    hot:      'has Lagoon\'s strongest cooling',
    snore:    'positions your airway for easier breathing',
    wrinkles: 'low contact reduces face pressure',
    none:     'is our most-loved all-rounder',
  },
  position: {
    side:    'shaped for side sleepers',
    back:    'shaped for back sleepers',
    stomach: 'soft and low — kind to stomach sleepers',
    combo:   'adapts as you switch positions',
  },
  temp: {
    hot:     'sleeps the coolest in our line',
    neutral: 'temperature-neutral fill',
    cold:    'cozy and warmth-retaining',
  },
  body: {
    slender: 'matched to a slender build',
    average: 'sized for an average build',
    broad:   'lifts broad shoulders into alignment',
  },
  density: {
    soft:    'soft, cloud-like feel',
    cushy:   'cushy with gentle cradle',
    firm:    'firm and structured',
    notsure: 'balanced feel most people love',
  },
  height: {
    low:     'low-loft profile',
    medium:  'medium-loft profile',
    high:    'higher-loft profile',
    notsure: 'medium-loft — the safe pick',
  },
};


/* === pillow-specs.js === */
// pillow-specs.js
// Hard specs + chart-style positioning derived from the official Lagoon
// "Which Pillow Is Right for You?" comparison charts. These are the numbers
// Lumi uses for "why this pillow over that pillow" explanations.

window.LAGOON_PILLOW_SPECS = {
  otter: {
    name:        'The Otter',
    image:       'assets/pillow-otter.png',
    bestFor:     'All Positions',
    firmness:    6,
    cooling:     'Cool',
    height:      'High',
    badge:       'Most Popular',
    headline:    'The daily-driver cool pillow.',
    sub:         'Cool-to-the-touch cover · gel memory foam · adjustable.',
  },
  fox: {
    name:        'The Fox',
    image:       'assets/pillow-fox.png',
    bestFor:     'All Positions',
    firmness:    5,
    cooling:     'Neutral',
    height:      'Medium',
    badge:       'Highest Rated',
    headline:    'GQ\'s top-rated versatile pillow.',
    sub:         'Shredded memory foam · adjustable · combo-sleeper favorite.',
  },
  polarbear: {
    name:        'The Polar Bear',
    image:       'assets/pillow-polarbear.png',
    bestFor:     'Side Sleepers',
    firmness:    8,
    cooling:     'Coolest',
    height:      'Highest',
    badge:       'Favorite for side sleepers',
    headline:    'The coolest, most supportive pillow we make.',
    sub:         'Phase-change cover · reversible · adjustable fill.',
  },
  chinchilla: {
    name:        'The Chinchilla',
    image:       'assets/pillow-chinchilla.png',
    bestFor:     'Stomach',
    firmness:    1,
    cooling:     'Neutral',
    height:      'Low',
    badge:       'Plush Softness',
    headline:    'The cloud-soft stomach-sleeper pillow.',
    sub:         'Ultra-soft microfiber · adjustable · plush.',
  },
  puffin: {
    name:        'The Puffin',
    image:       'assets/pillow-puffin.png',
    bestFor:     'Stomach/Back Sleepers',
    firmness:    3,
    cooling:     'Neutral',
    height:      'Low',
    badge:       'Most Underrated',
    headline:    'Soft yet supportive down-alternative.',
    sub:         'Down-alternative microfiber · adjustable · plush + structured.',
  },
};

// Build a 2-3 bullet "why A over B" comparison given two pillow ids and
// the visitor's profile. Surfaces the meaningful differences first.
window.LAGOON_COMPARE = function(aId, bId, profile = {}) {
  const A = window.LAGOON_PILLOW_SPECS[aId];
  const B = window.LAGOON_PILLOW_SPECS[bId];
  if (!A || !B) return null;

  const reasons = [];

  // Cooling difference
  const coolRank = { Neutral: 0, Cool: 1, Coolest: 2 };
  if (coolRank[A.cooling] !== coolRank[B.cooling]) {
    if (coolRank[A.cooling] > coolRank[B.cooling]) {
      reasons.push(`${A.name} runs ${A.cooling.toLowerCase()} vs ${B.name}'s ${B.cooling.toLowerCase()} — better for hot sleepers.`);
    } else {
      reasons.push(`${B.name} is ${B.cooling.toLowerCase()}, but cooling isn't a priority for you — ${A.name} is the better daily fit.`);
    }
  }

  // Firmness difference
  if (Math.abs(A.firmness - B.firmness) >= 2) {
    const firmer = A.firmness > B.firmness ? A : B;
    const softer = A.firmness > B.firmness ? B : A;
    reasons.push(`${firmer.name} is firmer (${firmer.firmness}/10) and ${softer.name} is softer (${softer.firmness}/10).`);
  }

  // Height / loft difference
  const heightRank = { Low: 1, Medium: 2, High: 3, Highest: 4 };
  const hA = heightRank[A.height] || 2;
  const hB = heightRank[B.height] || 2;
  if (Math.abs(hA - hB) >= 1) {
    const taller = hA > hB ? A : B;
    const shorter = hA > hB ? B : A;
    reasons.push(`${taller.name} has more loft (${taller.height.toLowerCase()}) — better for ${taller.bestFor === 'Side Sleepers' ? 'broader shoulders' : 'side and back sleepers'}.`);
  }

  // Position fit
  if (A.bestFor !== B.bestFor) {
    if (profile.position === 'stomach' && (A.bestFor.includes('Stomach') || B.bestFor.includes('Stomach'))) {
      const stomachOne = A.bestFor.includes('Stomach') ? A : B;
      reasons.push(`${stomachOne.name} is built for stomach sleepers; the other is too tall.`);
    } else if (profile.position === 'side') {
      reasons.push(`${A.bestFor === 'Side Sleepers' ? A.name : A.bestFor === 'All Positions' ? A.name : B.name} is shaped for side sleepers specifically.`);
    }
  }

  return {
    a: A,
    b: B,
    reasons: reasons.slice(0, 3),
    // Suggested headline for the "why A over B" copy
    headline: `Why ${A.name} over ${B.name}?`,
  };
};


/* === pillow-gallery.js === */
// pillow-gallery.js
// Image-set URLs for each pillow, pulled from the live Lagoon PDPs
// (cdn.shopify.com). These are the same images the production product pages
// use — referencing the CDN URLs means we share the browser cache with the
// PDP and don't have to re-host images.
//
// Some URLs are best-effort guesses based on Shopify's filename convention
// (the Otter set was verified from the PDP HTML; Fox/Polar Bear/Chinchilla/
// Puffin should be verified or replaced with the real URLs from each PDP).
// The carousel falls back to assets/pillow-<id>.png if a CDN URL 404s.

window.LAGOON_PILLOW_GALLERY = {
  "otter": [
    "https://lagoonsleep.com/cdn/shop/files/Otter_-_1_4_1280x.png?v=1776804544",
    "https://lagoonsleep.com/cdn/shop/files/Copy_of_Website_-_Product_Page_Images_-_Square_1_1280x.gif?v=1776804544",
    "https://lagoonsleep.com/cdn/shop/files/Adjustable_-_Otter_0a2af912-f0af-4958-a617-21fd034c9d13_1280x.png?v=1766518371",
    "https://lagoonsleep.com/cdn/shop/files/otter_sleep_position_1_1280x.png?v=1766518371",
    "https://lagoonsleep.com/cdn/shop/files/Otter_sleep_position_2_1280x.png?v=1766518371",
    "https://lagoonsleep.com/cdn/shop/files/Otter_-_Adjustable_Height_GIF_2_1280x.gif?v=1766518371",
    "https://lagoonsleep.com/cdn/shop/files/Otter_-_Earned_Insider_1280x.png?v=1766518371",
    "https://lagoonsleep.com/cdn/shop/files/Otter_-_Certipur_1280x.png?v=1766518371"
  ],
  "fox": [
    "https://lagoonsleep.com/cdn/shop/files/Fox_-_1_-_GQ_1_1280x.png?v=1776804544",
    "https://lagoonsleep.com/cdn/shop/files/Fox_Softness_1280x.gif?v=1776804544",
    "https://lagoonsleep.com/cdn/shop/files/Adjustable_-_Fox_a0b22976-5c20-438c-81fc-b7e39cec6c57_1280x.png?v=1766518255",
    "https://lagoonsleep.com/cdn/shop/files/Fox_sleep_position_1_1280x.png?v=1766518255",
    "https://lagoonsleep.com/cdn/shop/files/Fox_-_Adjustable_Height_GIF_3_1280x.gif?v=1766518255",
    "https://lagoonsleep.com/cdn/shop/files/Fox_-_Earned_-_GQ_1280x.png?v=1766518255",
    "https://lagoonsleep.com/cdn/shop/files/White_Shredded_Memory_Foam_c151bf9d-61cb-4cfc-ab9c-0cd03ca48024_1280x.png?v=1766518255",
    "https://lagoonsleep.com/cdn/shop/files/Grayson_Fox_1280x.png?v=1766518255",
    "https://lagoonsleep.com/cdn/shop/files/pillow_cover_shell_attributes_1280x.png?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/Fox_sleep_position_2_1280x.png?v=1766518255",
    "https://lagoonsleep.com/cdn/shop/files/otter_sleep_position_3_1280x.png?v=1766519979"
  ],
  "polarbear": [
    "https://lagoonsleep.com/cdn/shop/files/Polar_Bear_-_1_1280x.png?v=1776804544",
    "https://lagoonsleep.com/cdn/shop/files/Polar_Bear_-_Image_1_1280x.png?v=1766518468",
    "https://lagoonsleep.com/cdn/shop/files/Polar_Bear_-_Reversible_1280x.png?v=1766518468",
    "https://lagoonsleep.com/cdn/shop/files/Polar_Bear_-_Certipur_1280x.png?v=1766518468",
    "https://lagoonsleep.com/cdn/shop/files/Polar_Bear_-_Trusted_by_Pros_1280x.png?v=1766518468",
    "https://lagoonsleep.com/cdn/shop/files/pillow_cover_shell_attributes_1280x.png?v=1766519979"
  ],
  "chinchilla": [
    "https://lagoonsleep.com/cdn/shop/files/Chinchilla_-_1v2_1280x.png?v=1776804544",
    "https://lagoonsleep.com/cdn/shop/files/ProductPage-LifestyleImages_8_1280x.gif?v=1766519956",
    "https://lagoonsleep.com/cdn/shop/files/Adjustable_-_Chinchilla_205fe0ce-e312-4d2a-8e83-39223d389ce5_1280x.png?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/Chinchilla_-_Adjustable_Height_GIF_5_1280x.gif?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/Chinchilla_-_Earned_1280x.png?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/Corey_Chinchilla_1280x.png?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/pillow_cover_shell_attributes_1280x.png?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/chinchilla_sleep_position_1_1280x.png?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/chinchilla_sleep_position_2_1280x.png?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/otter_sleep_position_3_1280x.png?v=1766519979"
  ],
  "puffin": [
    "https://lagoonsleep.com/cdn/shop/files/Puffin_-_1_1_1280x.png?v=1776804544",
    "https://lagoonsleep.com/cdn/shop/files/Puffin_Softness_1280x.gif?v=1776804544",
    "https://lagoonsleep.com/cdn/shop/files/Adjustable_-_Chinchilla_205fe0ce-e312-4d2a-8e83-39223d389ce5_1280x.png?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/Puffin_-_Adjustable_Height_GIF_4_1280x.gif?v=1766519919",
    "https://lagoonsleep.com/cdn/shop/files/pillow_cover_shell_attributes_1280x.png?v=1766519979",
    "https://lagoonsleep.com/cdn/shop/files/Puffin_sleep_position_2_1280x.png?v=1766519919",
    "https://lagoonsleep.com/cdn/shop/files/puffin_sleep_position_1_1280x.png?v=1766519919",
    "https://lagoonsleep.com/cdn/shop/files/otter_sleep_position_3_1280x.png?v=1766519979"
  ]
};


/* === reviews-data.js === */
// reviews-data.js — Curated verified-buyer reviews + misfit flags
// Sourced from Lagoon Fera reviews (March 2026 export, 707 reviews).
// Used by the concierge agent in two ways:
//   1. The recommendation card surfaces ONE quote per match.
//   2. The system prompt receives summaries so Lumi can speak in
//      verified-buyer language ("Other side sleepers with neck pain...").
//   3. MISFIT_FLAGS are hard "do not recommend" signals pulled from
//      1-2 star returns — they down-weight wrong matches.

window.LAGOON_REVIEWS = {
  "otter": [
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "As advertised - cooling and supportive! Love this pillow (about 3 weeks in) and it's helping a lot with my shoulder pain (I'm a side sleeper)",
      "by": "Liz · Santa Cruz"
    },
    {
      "rating": 5,
      "title": "Love the feel of this pillow!",
      "body": "I’ve traditionally been a stomach/side sleeper, but I hurt my back several months ago and can now only sleep on my back. This pillow is awesome! I love the feel, slow sink (but actual sink, unlike other foam / non-shredded foam pillows), and support of this pillow!",
      "by": "Nicole · League City"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "I absolutely love the otter pillow. My head just sinks right into it and off to sleep I go. I wake up refreshed and in a good mood. It also keeps me cool when the weather get warm as well since it’s supportive and I’m not being swallowed by fluff.",
      "by": "Liz · Oreland"
    },
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "I wake up with no neck pain and I sleep comfortably throughout the night.",
      "by": "Julia · Aurora"
    },
    {
      "rating": 5,
      "title": "Excellent!",
      "body": "This pillow is amazing! I sleep so much better and my back and neck pain is gone! Would definitely recommend. I plan to purchase one for my husband, too.",
      "by": "emily · lafayette"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "love that it is cool and that i can shape it so my neck is in alignment... i sleep so much better... Thank you",
      "by": "Elizabeth · Laguna Beach"
    }
  ],
  "fox": [
    {
      "rating": 5,
      "title": "Great!",
      "body": "This is an excellent pillow! I am a side sleeper and it provides great head and neck support to keep my spine in good alignment. Also it is extremely comfortable!",
      "by": "Verified · Victoria"
    },
    {
      "rating": 5,
      "title": "How great!",
      "body": "I love how soft and supportive this pillow is. Even when you are sinking into the plushness of the pillow it still supports your neck and head perfectly.",
      "by": "Jeannine · Ventura"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "I love this pillow, I haven’t woken up with neck pain since I got it and I feel like I am better rested when I wake up!",
      "by": "Emma · Elk Point"
    },
    {
      "rating": 5,
      "title": "Impressive comfort and support!",
      "body": "After receiving my Otter pillow, I was impressed by its initial comfort. I did remove some fill after the first night to customize it to my liking, and since then, it has been perfect. The Otter pillow provides just the right support for my neck and back, allowing me to wake up feeling refreshed and without any stiffness. What I love most is how quickly it helps me fall asleep as soon as I lie down with it. Unlike my previous pillow, the Otter pillow isn't too firm, yet it still provides excellent support. This has significantly reduced my neck and shoulder pain, making my sleep experience truly restorative. I highly recommend the Otter pillow for anyone looking for a comfortable and supportive solution to their sleep needs.",
      "by": "Alyanna · Laguna"
    },
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "I love the cushion and support. I finally wake up without my neck hurting!",
      "by": "Rebecca · Roswell"
    },
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "I loved having the adjustable filling to make my pillow feel just right! My head is supported, but the pillow is still so soft. The perfect combination.",
      "by": "Elizabeth · Media"
    }
  ],
  "chinchilla": [
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "This is the best pillow I have ever purchased. I am a side/back sleeper with a bad neck and since purchase have not woke up with any neck pain. It’s so soft and cozy! I tell EVERYONE about my pillow! Highly recommend it!",
      "by": "Nordstrom · Princeton"
    },
    {
      "rating": 5,
      "title": "",
      "body": "I bought this second pillow. Its sift and nit firm. Its cool and comfortable. It’s the first pillow that I found that i love and sleep so well on.",
      "by": "CONNIE · Saint Petersburg"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "I have frequent neck pain and am a side-sleeper, but this pillow has been a game changer! I’ve had it for a month and do not wake up with pain! The pillow’s soft, but with enough support and compresses so comfortably under my head.",
      "by": "Nassim · Bellingham"
    },
    {
      "rating": 5,
      "title": "Great !!",
      "body": "I love the softness and instant comfort I feel when I lay my head on the pillow at night. It makes for a restful sleep each night. I love this pillow. The best pillow I have ever had. Thank you so much",
      "by": "Susan · Minneapolis"
    },
    {
      "rating": 5,
      "title": "Lovely!",
      "body": "I have tried just about every type of pillow in search of comfort. I am a side and back sleeper who gets migraines and occasional neck pain. I have found I like the soft feel of a down alternative, but also need the adjustable support. This pillow is perfect! The quality is great and it is the softest I've found. My only small complaint is that I wish it came with a little extra filling in case you need it. I did need to purchase more to get it just right. That aside I do recommend this pillow. Also the customer service at Lagoon is awesome. I tried the Otter first and it didn't work out. However I was easily able to return without issue. A little while later I am back and in love with the Chinchilla.! Thanks Lagoon!",
      "by": "Jaclyn · Bay Village"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "My husband and I have been looking for a new pillow for a long time now. We have gone through trying many highly rated pillows and have finally found the ones with Lagoon Sleeps Chinchilla Pillow. We both love our new pillows! My husband is more of a back sleeper and I am more of a side sleeper. We both tend to like a softer pillow. The Chinchilla was perfect for both of us. It gave that cloud like sink in feel we were looking for a the adjustable fill made it possible for us to each customize the loft to fit our liking (his a little more lofty and mine a little less). I would highly recommend!",
      "by": "Samantha · Covington"
    }
  ],
  "puffin": [
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "I love everything about this pillow. I am a stomach sleeper and finding a good pillow is almost impossible. Love this!",
      "by": "Matthew · Brentwood"
    },
    {
      "rating": 5,
      "title": "The Perfect Pillow (for me)",
      "body": "I love a minimal, soft pillow and with the quiz Lagoon absolutely nailed it! This is the softest pillow I have ever had, absolutely love my Puffin pillow!",
      "by": "Lynnette · Cary"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "It's the perfect height for a stomach sleeper. A huge improvement over my current Avocado pillow.",
      "by": "Nicholas · Minneapolis"
    },
    {
      "rating": 5,
      "title": "My husband LOVES the puffin",
      "body": "He sleeps on his stomach and has always used really crummy pillows. I'm so happy to have finally found him one that works well... I can now finally throw out the others - yes!",
      "by": "Maria · Washington DC"
    },
    {
      "rating": 5,
      "title": "Can't sleep without it",
      "body": "I don't know if it's the pillow or the mindset I have because of the pillow, but I've been getting the best sleep of my life since I started using the pillows from Lagoon.",
      "by": "Jake · Minneapolis"
    },
    {
      "rating": 5,
      "title": "The search is over!",
      "body": "I’ve bought (and tossed) too many pillows to count! This one, however, will NOT get tossed because it’s absolutely perfect! I’m a stomach sleeper and The Puffin is so comfy. No more pillow shopping for me!",
      "by": "Marge · Boise"
    }
  ],
  "polarbear": [
    {
      "rating": 5,
      "title": "Holy Grail of pillows!",
      "body": "This thing is amazing! so adjustable and so comfortable. Stuart Scott would be happy- it's as cool as the other side of the pillow",
      "by": "Kenton · Pittsburgh"
    },
    {
      "rating": 5,
      "title": "The gold standard of pillows",
      "body": "As a marathon runner and a mom, sleep is one of the most important parts of recovery for me. The Lagoon Polar Bear pillow has been fantastic. I love that it’s adjustable so you can customize the height and support. I’m typically a side sleeper and it provides great neck support without feeling too firm or too flat. The pillow is so good I actually had to order more because my husband and kids kept trying to steal mine. When it comes to comfort, support, and thoughtful design, Lagoon really feels like the gold standard.",
      "by": "Kayla · Richmond Hill"
    }
  ]
};

window.LAGOON_REVIEW_SUMMARIES = {
  "otter": "Most loved by side sleepers with neck/shoulder pain. Real reviews: \"no neck pain\", \"head sinks right in\", \"alignment is perfect\", \"wake up refreshed\". Lightly cooling but visitors who NEED strong cooling should be steered to Polar Bear instead. Bulky for stomach sleepers — avoid that match.",
  "fox": "The brand best-seller and GQ-pick for combo sleepers. Adjustable fill is a key selling point — buyers love being able to remove fill to dial-in feel. Real reviews: \"no neck pain since I got it\", \"soft and supportive\", \"perfect cushion and support\". WARNING: side sleepers with broad shoulders sometimes find it under-supportive — those should go to Otter.",
  "chinchilla": "Soft, low-loft, \"sink in\" feel. Adored by side/back sleepers with neck pain who prefer plush over firm. Real reviews: \"best pillow ever\", \"neck pain gone\", \"instant comfort\". TOO SOFT for anyone who explicitly wants firm support.",
  "puffin": "Stomach-sleeper favorite. Reviews: \"perfect height for a stomach sleeper\", \"huge improvement\", \"search is over\". Soft + low-loft, kind to face-down sleepers. Also good for cold sleepers.",
  "polarbear": "The coolest pillow Lagoon makes. Adjustable fill. Reviews mention recovery sleep, marathon runners, \"as cool as the other side of the pillow\". Specifically for HOT sleepers who also want adjustability. Don't recommend to cold sleepers."
};

window.LAGOON_MISFIT_FLAGS = {
  "otter": [
    {
      "dim": "position",
      "value": "stomach",
      "penalty": 8,
      "why": "returns flagged \"too bulky for stomach sleepers\""
    },
    {
      "dim": "concern",
      "value": "hot",
      "penalty": 3,
      "why": "hot-sleepers expecting strong cooling are sometimes disappointed — Polar Bear is the better cooling answer"
    }
  ],
  "fox": [
    {
      "dim": "position",
      "value": "side",
      "penalty": 0,
      "why": "fine for most side sleepers"
    }
  ],
  "chinchilla": [
    {
      "dim": "density",
      "value": "firm",
      "penalty": 8,
      "why": "\"too soft\" complaints from firm-feel buyers"
    },
    {
      "dim": "body",
      "value": "broad",
      "penalty": 5,
      "why": "sinks too far for broad shoulders"
    }
  ],
  "puffin": [],
  "polarbear": [
    {
      "dim": "temp",
      "value": "cold",
      "penalty": 8,
      "why": "too cooling for cold sleepers"
    },
    {
      "dim": "density",
      "value": "soft",
      "penalty": 5,
      "why": "firmer than soft-feel buyers want"
    }
  ]
};

window.LAGOON_MISFIT_COMBOS = [
  {
    "pillow": "fox",
    "when": {
      "position": "side",
      "body": "broad"
    },
    "penalty": 6,
    "why": "broad-shouldered side sleepers report under-support — steer to Otter"
  },
  {
    "pillow": "chinchilla",
    "when": {
      "position": "side",
      "body": "broad"
    },
    "penalty": 8,
    "why": "too low/soft for broad-shouldered side sleepers"
  },
  {
    "pillow": "puffin",
    "when": {
      "temp": "hot"
    },
    "penalty": 7,
    "why": "Puffin is temp-neutral — wrong for hot sleepers"
  },
  {
    "pillow": "fox",
    "when": {
      "temp": "hot"
    },
    "penalty": 7,
    "why": "Fox is temp-neutral — Otter or Polar Bear is the cooling answer"
  },
  {
    "pillow": "chinchilla",
    "when": {
      "temp": "hot"
    },
    "penalty": 7,
    "why": "Chinchilla is temp-neutral — wrong for hot sleepers"
  }
];

/* === support-knowledge.js === */
// support-knowledge.js
// Derived from 4,206 Gorgias tickets (May 2026 export). The bulk of tickets
// are operational (shipping 36% / returns 15%), which informs the agent's
// implicit positioning — visitors trust the 100-night trial only if it's
// reinforced in the conversation. The remaining signal is:
//
//   - 18 "product question" tickets pre-purchase (sizing, fill, washability)
//   - Multiple "what pillow for [specific medical issue]" inbound emails
//   - "Your promo codes don't work" complaints — code clarity matters
//
// This file gives the agent two things:
//   1. window.LAGOON_FAQ: facts Lumi can quote when asked
//   2. window.LAGOON_HANDOFF_RULES: cases where Lumi should hand off to a
//      human (CX team) instead of guessing

window.LAGOON_FAQ = {
  trial:
    "Every Lagoon pillow has a 100-night risk-free trial. Sleep on it, and if it's not right return it for a full refund — no questions, no return shipping fee.",
  warranty:
    "All Lagoon pillows come with a 5-year warranty against defects.",
  adjustable_fill:
    "The Fox and Polar Bear have adjustable fill — unzip the inner cover and remove handfuls of fill until it feels right. The Chinchilla, Puffin, and Otter ship at a fixed loft (no adjustment).",
  washable:
    "The outer cover is machine washable on a gentle, cold cycle. Don't put the inner foam/fill core in the wash — spot-clean only.",
  sizing:
    "Two sizes: Queen ($139.99 — standard pillowcase fit) and King ($159.99 — fits a king pillowcase). The Polar Bear is $199.99 in either size due to the adjustable cooling system.",
  shipping:
    "Free shipping to the contiguous US, usually 3–5 business days from when you order. Free returns too.",
  materials:
    "Lagoon pillows are CertiPUR-US certified, hypoallergenic, and made without harmful chemicals. The Fox uses shredded memory foam; the Otter and Polar Bear use a cooling memory foam blend.",
  cooling_tech:
    "The Polar Bear is the strongest cooling pillow — it uses a phase-change cover plus cooling-infused fill. The Otter has cooling fill but a standard cover. The Fox, Chinchilla, and Puffin are temperature-neutral.",
  vs_quiz:
    "This chat replaces our 2-minute quiz. The recommendation engine and customer profile are identical — just delivered as a conversation.",
};

window.LAGOON_HANDOFF_RULES = [
  {
    when: 'visitor mentions a specific medical condition, recent surgery, herniated disc, metal hardware, or chronic pain that needs professional input',
    response: "That sounds like something worth checking with your doctor or PT before I recommend a pillow. If you'd like, our sleep team can also help — email hi@lagoonsleep.com or chat with us directly. I can still suggest a starting point if that helps.",
  },
  {
    when: 'visitor wants to combine multiple pillows (e.g. body pillow + head pillow), exchange a specific order, or modify an existing purchase',
    response: "For order changes or returns, the fastest path is our support team at hi@lagoonsleep.com — they can pull up your order. I'm here for the pillow fit itself.",
  },
];

// Promo policy — surface ONCE per session, in the recommendation card.
// Earlier appearance is fine in nav/announcement bar but Lumi shouldn't pitch
// discounts mid-conversation (it cheapens the consultation feel).
window.LAGOON_PROMO = {
  code: 'WELCOME20',
  amount_off: 20,
  applies_to: 'any pillow + accompanying pillowcase and/or travel pillow',
  trial: '100 nights',
  url: 'https://lagoonsleep.com/discount/WELCOME20',
};


/* === telemetry.js === */
// telemetry.js
// Sends Lumi conversation events to your backend so the knowledge base can
// learn from production. Zero PII before email submit; full profile after.
//
// PRODUCTION WIRING:
//   window.LAGOON_TELEMETRY_ENDPOINT = '/api/lumi/event';   // your backend URL
//   window.LAGOON_TELEMETRY_SAMPLE   = 1.0;                  // 0..1 sample rate
//
// EVENTS LOGGED:
//   conversation_started       first user turn
//   user_turn                  every user message (text + inferred profile delta)
//   assistant_turn             every Lumi message (text + confidence)
//   profile_field_inferred     a new dimension got pinned (which one + value)
//   recommendation_shown       a rec was rendered (top + runner-up + complement)
//   email_captured             email submitted → Klaviyo sync
//   shop_clicked               visitor clicked the buy CTA
//   handoff_triggered          medical_flag fired
//   conversation_abandoned     visitor closed/refreshed without a rec
//   off_topic_detected         visitor went off-topic (mattress, etc.)
//   parse_error                LLM returned non-JSON or invalid schema
//
// All events include a stable per-visitor `session_id` (rotates every 30 days)
// and a `conversation_id` (one per chat). Email is only attached AFTER it's
// submitted — no PII leakage on anonymous turns.

(function () {
  const SAMPLE = typeof window.LAGOON_TELEMETRY_SAMPLE === 'number'
    ? window.LAGOON_TELEMETRY_SAMPLE : 1.0;
  const ENDPOINT = window.LAGOON_TELEMETRY_ENDPOINT || null;
  const QUEUE_KEY = 'lagoon.lumi.telemetry.queue.v1';
  const SESSION_KEY = 'lagoon.lumi.session_id.v1';
  const CONV_KEY = 'lagoon.lumi.conversation_id.v1';

  function getSessionId() {
    try {
      const raw = localStorage.getItem(SESSION_KEY);
      if (raw) {
        const o = JSON.parse(raw);
        if (Date.now() - o.created < 30 * 24 * 60 * 60 * 1000) return o.id;
      }
    } catch (e) {}
    const id = 'ses_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    try { localStorage.setItem(SESSION_KEY, JSON.stringify({ id, created: Date.now() })); } catch (e) {}
    return id;
  }

  function getConversationId() {
    try {
      const existing = sessionStorage.getItem(CONV_KEY);
      if (existing) return existing;
    } catch (e) {}
    const id = 'cnv_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    try { sessionStorage.setItem(CONV_KEY, id); } catch (e) {}
    return id;
  }

  function resetConversation() {
    try { sessionStorage.removeItem(CONV_KEY); } catch (e) {}
  }

  // Queue + flush — uses sendBeacon when available so events survive page
  // unloads. Falls back to fetch with keepalive.
  let queue = [];
  try { queue = JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]'); } catch (e) {}

  function persistQueue() {
    try { localStorage.setItem(QUEUE_KEY, JSON.stringify(queue.slice(-200))); } catch (e) {}
  }

  async function flush() {
    if (!ENDPOINT || queue.length === 0) return;
    const batch = queue.slice();
    queue = [];
    persistQueue();
    const body = JSON.stringify({ events: batch });
    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon(ENDPOINT, blob)) return;
      }
      await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      });
    } catch (e) {
      // restore queue so we retry next page load
      queue = batch.concat(queue);
      persistQueue();
    }
  }

  function track(eventName, payload = {}) {
    if (Math.random() > SAMPLE) return;
    let email = null;
    try { email = localStorage.getItem('lagoon.lumi.email.v1'); } catch (e) {}
    const event = {
      event: eventName,
      ts: Date.now(),
      session_id: getSessionId(),
      conversation_id: getConversationId(),
      email,                              // null until visitor submits
      ua: navigator.userAgent,
      page: location.pathname,
      ...payload,
    };
    queue.push(event);
    persistQueue();
    // batch flush on idle or after 4 events
    if (queue.length >= 4) flush();
    else requestIdleCallback ? requestIdleCallback(flush) : setTimeout(flush, 800);
  }

  // Flush on page unload so we don't lose tail events
  window.addEventListener('beforeunload', flush);
  window.addEventListener('pagehide', flush);

  // Retry queue on next page load
  if (queue.length) setTimeout(flush, 1500);

  window.lumiTrack = track;
  window.lumiResetConversation = resetConversation;
})();


/* === klaviyo-bridge.js === */
// klaviyo-bridge.js
// Maps the Lumi profile to the EXISTING Lagoon Klaviyo schema (so Lumi
// profiles slot into the same cohorts/flows the current pillow quiz feeds).
//
// Schema kept identical to the quiz:
//   wake_up_position   single  "Side" | "Back" | "Stomach" | "Changes all the time"
//   density            single  "Soft & Cloud-like" | "Cushy & Cradling" | "Firm & Supportive" | "Not sure"
//   body_type          single  "Slender" | "Average" | "Broad"
//   height             single  "Lower loft" | "Medium loft" | "Higher loft" | "I'm not sure"
//   sleep_issues       multi   comma-joined display strings (see ISSUE_LABELS)
//   sleep_goals        multi   comma-joined display strings (see GOAL_LABELS)
//   result1_name       single  "The Otter" etc.
//   Pillowcase         single  "Cooling Flex" | "Silk Luxe" (when complement was accepted)
//   Entered Welcome Flow  "Yes"
//   Accepts Marketing  true
//
// On submit we also subscribe the profile to the "Cartful Solutions" list so
// the existing lifecycle flows fire. Set window.LAGOON_KLAVIYO_LIST_ID to
// the Cartful Solutions list ID.
//
// PRODUCTION WIRING:
//   window.LAGOON_KLAVIYO_PUBLIC_KEY = '<6-char site ID>';
//   window.LAGOON_KLAVIYO_LIST_ID    = '<Cartful Solutions list ID>';
//   // optional — preferred over public-key for production:
//   window.LAGOON_KLAVIYO_PROXY = 'https://your.backend/klaviyo-identify';
//
// LOCAL STORAGE KEYS:
//   lagoon.lumi.session.v1    full conversation + profile + recommendation
//   lagoon.lumi.email.v1      submitted email (so we don't re-prompt)
//   lagoon.lumi.synced.v1     {syncedAt, props, pending} sync receipt

window.LAGOON_KLAVIYO_PUBLIC_KEY = window.LAGOON_KLAVIYO_PUBLIC_KEY || null;
window.LAGOON_KLAVIYO_PROXY      = window.LAGOON_KLAVIYO_PROXY      || null;
window.LAGOON_KLAVIYO_LIST_ID    = window.LAGOON_KLAVIYO_LIST_ID    || null;

// ─────────────────────────────────────────────────────────────
// Display-label maps — match the existing quiz's Klaviyo values exactly.
// ─────────────────────────────────────────────────────────────

const POSITION_LABELS = {
  side: 'Side',
  back: 'Back',
  stomach: 'Stomach',
  combo: 'Changes all the time',
};

const DENSITY_LABELS = {
  soft: 'Soft & Cloud-like',
  cushy: 'Cushy & Cradling',
  firm: 'Firm & Supportive',
  notsure: 'Not sure',
};

const BODY_LABELS = {
  slender: 'Slender',
  average: 'Average',
  broad: 'Broad',
};

const HEIGHT_LABELS = {
  low: 'Lower loft',
  medium: 'Medium loft',
  high: 'Higher loft',
  notsure: "I'm not sure",
};

const ISSUE_LABELS = {
  toss:     'I toss & turn too much',
  neck:     'I wake up with neck or shoulder pain',
  hot:      'I sleep hot & need cooling',
  snore:    'I snore or have trouble breathing',
  wrinkles: 'I worry about face wrinkles & pressure',
  none:     'No issues, just looking for an upgrade',
};

const GOAL_LABELS = {
  fall_asleep_faster: 'Fall asleep faster',
  deep_sleep:         'Get more deep & REM sleep',
  pain_free:          'Wake up pain-free',
  cool:               'Stay cool all night',
  upgrading:          'Just upgrading',
};

const PILLOW_LABELS = {
  otter:      'The Otter',
  fox:        'The Fox',
  chinchilla: 'The Chinchilla',
  puffin:     'The Puffin',
  polarbear:  'The Polar Bear',
};

const PILLOWCASE_LABELS = {
  'cooling-pillowcase': 'Cooling Flex',
  'silk-pillowcase':    'Silk Luxe',
};

// Build the Klaviyo property payload from a Lumi profile + recommendation.
// Skips empty values so we don't blow away existing properties with blanks.
function mapProfileToKlaviyo(p, recommendation, email) {
  // sleep_issues is multi-select. Internal model uses `concerns` (array) OR
  // `concern` (legacy single). Also: temp=hot maps into sleep_issues since
  // the existing schema doesn't have a separate temp field — that's how
  // hot-sleeper segmentation works today.
  const issues = new Set();
  if (Array.isArray(p.concerns)) p.concerns.forEach(c => ISSUE_LABELS[c] && issues.add(ISSUE_LABELS[c]));
  if (p.concern && ISSUE_LABELS[p.concern]) issues.add(ISSUE_LABELS[p.concern]);
  if (p.temp === 'hot' && !issues.has(ISSUE_LABELS.hot)) issues.add(ISSUE_LABELS.hot);

  // sleep_goals — already an array in the Lumi model
  const goals = Array.isArray(p.goals)
    ? p.goals.map(g => GOAL_LABELS[g]).filter(Boolean)
    : [];

  const out = {
    // Klaviyo reserved
    $email: email || p.email,
    $consent: ['email'],
    'Accepts Marketing': true,

    // EXISTING quiz schema — same keys and value formats
    wake_up_position: POSITION_LABELS[p.position] || null,
    density:          DENSITY_LABELS[p.density]   || null,
    body_type:        BODY_LABELS[p.body]         || null,
    height:           HEIGHT_LABELS[p.height]     || null,
    sleep_issues:     issues.size ? [...issues].join(',') : null,
    sleep_goals:      goals.length ? goals.join(',') : null,
    result1_name:     PILLOW_LABELS[recommendation?.pillow_id] || null,
    Pillowcase:       PILLOWCASE_LABELS[recommendation?.complement?.id] || null,
    'Entered Welcome Flow': 'Yes',

    // Lumi-specific properties — useful but namespaced so they don't
    // collide with existing reporting. Optional to consume.
    lumi_runner_up:              PILLOW_LABELS[recommendation?.runner_up_id] || null,
    lumi_recommended_confidence: recommendation?.confidence || null,
    lumi_buying_for:             p.buying_for || null,
    lumi_medical_flag:           p.medical_flag === true ? true : null,
    lumi_source:                 'lagoon-sleep-concierge',
    lumi_session_completed_at:   new Date().toISOString(),
  };

  // Strip empty/null so Klaviyo doesn't clear existing values
  Object.keys(out).forEach(k => {
    const v = out[k];
    if (v === null || v === undefined || v === '') delete out[k];
  });
  return out;
}

// Submit the profile to Klaviyo + subscribe to Cartful Solutions list.
// Prefers server proxy when configured; otherwise uses public client API.
window.lagoonSyncToKlaviyo = async function({ email, profile, recommendation }) {
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return { ok: false, error: 'invalid-email' };
  }
  const props = mapProfileToKlaviyo(profile || {}, recommendation || {}, email);

  // Persist locally first so a network failure never loses the data
  try {
    localStorage.setItem('lagoon.lumi.email.v1', email);
    localStorage.setItem('lagoon.lumi.synced.v1', JSON.stringify({
      syncedAt: Date.now(), props, pending: true,
    }));
  } catch (e) {}

  // 1) Preferred: server proxy. Your backend uses the Klaviyo private key
  //    to identify + subscribe. Single endpoint, atomic.
  if (window.LAGOON_KLAVIYO_PROXY) {
    try {
      const res = await fetch(window.LAGOON_KLAVIYO_PROXY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          properties: props,
          list_id: window.LAGOON_KLAVIYO_LIST_ID,
        }),
      });
      if (!res.ok) throw new Error('proxy-' + res.status);
      markSynced(props);
      return { ok: true, via: 'proxy' };
    } catch (e) {
      console.warn('[lumi] proxy failed, falling back to client API', e);
    }
  }

  // 2) Fallback: public client API (no private key needed). Two calls —
  //    update profile properties, then subscribe to the list.
  if (window.LAGOON_KLAVIYO_PUBLIC_KEY) {
  try {
    await klaviyoUpdateProfile(email, props);
    console.log('[lumi debug] About to check list ID:', window.LAGOON_KLAVIYO_LIST_ID, typeof window.LAGOON_KLAVIYO_LIST_ID);
    if (window.LAGOON_KLAVIYO_LIST_ID) {
      console.log('[lumi debug] Calling klaviyoSubscribeToList NOW');
      await klaviyoSubscribeToList(email, window.LAGOON_KLAVIYO_LIST_ID);
      console.log('[lumi debug] klaviyoSubscribeToList returned');
    }
    await klaviyoTrackEvent(email, 'Filled Out Survey', props);
    markSynced(props);
    return { ok: true, via: 'client-api' };
  } catch (e) {
    console.error('[lumi] client API failed', e);
    return { ok: false, error: String(e) };
  }
}

  // 3) Demo mode — log the payload so the UX flow can be reviewed without
  //    live Klaviyo keys. Local storage still has it; production picks up
  //    on next visit when keys are wired.
  console.info('[lumi DEMO] Klaviyo payload:', { email, properties: props, list: window.LAGOON_KLAVIYO_LIST_ID || '(not set — would subscribe to Cartful Solutions)' });
  markSynced(props);
  return { ok: true, via: 'demo' };
};

async function klaviyoUpdateProfile(email, properties) {
  const customProps = Object.fromEntries(
    Object.entries(properties).filter(([k]) => !k.startsWith('$') && k !== 'Accepts Marketing')
  );
  const payload = {
    data: {
      type: 'profile',
      attributes: {
        email,
        properties: customProps,
      },
    },
  };
  const url = `https://a.klaviyo.com/client/profiles/?company_id=${window.LAGOON_KLAVIYO_PUBLIC_KEY}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-10-15',
    },
    body: JSON.stringify(payload),
  });
  // 409 is "profile already exists" — fine, properties merge.
  if (!res.ok && res.status !== 409) throw new Error('profile-' + res.status);
}

async function klaviyoSubscribeToList(email, listId) {
  const payload = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Lagoon Sleep Concierge',
        profile: {
          data: {
            type: 'profile',
            attributes: { email },
          },
        },
      },
      relationships: {
        list: { data: { type: 'list', id: listId } },
      },
    },
  };
  const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${window.LAGOON_KLAVIYO_PUBLIC_KEY}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-10-15',
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok && res.status !== 202) throw new Error('subscribe-' + res.status);
}

async function klaviyoTrackEvent(email, metric, properties) {
  const payload = {
    data: {
      type: 'event',
      attributes: {
        properties,
        metric: {
          data: {
            type: 'metric',
            attributes: { name: metric },
          },
        },
        profile: {
          data: {
            type: 'profile',
            attributes: { email },
          },
        },
      },
    },
  };
  const url = `https://a.klaviyo.com/client/events/?company_id=${window.LAGOON_KLAVIYO_PUBLIC_KEY}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2024-10-15',
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok && res.status !== 202) throw new Error('event-' + res.status);
}

function markSynced(props) {
  try {
    localStorage.setItem('lagoon.lumi.synced.v1', JSON.stringify({
      syncedAt: Date.now(), props, pending: false,
    }));
  } catch (e) {}
}

window.lagoonGetSavedEmail = function() {
  try { return localStorage.getItem('lagoon.lumi.email.v1') || null; }
  catch (e) { return null; }
};

window.lagoonClearKlaviyoState = function() {
  try {
    localStorage.removeItem('lagoon.lumi.email.v1');
    localStorage.removeItem('lagoon.lumi.synced.v1');
  } catch (e) {}
};

// Expose the label maps so the strategy artboard can render them
window.LAGOON_KLAVIYO_LABELS = {
  position: POSITION_LABELS,
  density:  DENSITY_LABELS,
  body:     BODY_LABELS,
  height:   HEIGHT_LABELS,
  issues:   ISSUE_LABELS,
  goals:    GOAL_LABELS,
  pillow:   PILLOW_LABELS,
  pillowcase: PILLOWCASE_LABELS,
};
